export const CARACTERIZACAO_SLUGS = {
  1: "armazem_geral",
  2: "revenda_e_representacao_comercial",
  3: "cooperativa",
  4: "condominio_rural",
  5: "propriedade_rural",
  6: "cerealista_e_comercializacao",
  7: "agroindustria",
  8: "pecas_e_agropecuaria",
  9: "unidade_de_recebimento_de_embalagens",
  99: "financeiro"
};
